import application from 'tw-framework'

// 启动应用
application.start()